import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

export interface AuthState {
	isAuthenticated: boolean;
	token: string | null;
	user: null | {
		firstName: string;
		lastName: string;
		email: string;
		userId: string;
	};
}

const initialState: AuthState = {
	token: Cookies.get("token") || null,
	isAuthenticated: !!Cookies.get("token"),
	user: {
		firstName: "",
		lastName: "",
		email: "",
		userId: "",
	},
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		setAuthToken(state, action) {
			state.token = action.payload;
			state.isAuthenticated = true;
			Cookies.set("token", action.payload, { expires: 1 });
		},
		setUser(state, action) {
			state.user = action.payload;
		},
		logout(state) {
			state.token = null;
			state.isAuthenticated = false;
			state.user = null;
			Cookies.remove("token");
		},
	},
});

export const { setAuthToken, logout, setUser } = authSlice.actions;
export default authSlice.reducer;
